;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import clsx from 'clsx'
import Link, { LinkProps } from 'next/link'

type TopBarAccountButtonRootProps = LinkProps & {
  className?: string
  children: React.ReactNode
}
export const TopBarAccountButtonRoot = ({
  children,
  className,
  ...props
}: TopBarAccountButtonRootProps) => {
  return (
    <Link
      className={clsx(
        className,
        'focus:ring-primary-700 rounded-full outline-hidden hover:bg-gray-100 focus:ring-2 active:shadow-[inset_0_4px_4px_rgba(0,0,0,0.25)]',
      )}
      {...props}
    >
      <div className="flex flex-row items-center gap-1 rounded-full">
        {children}
      </div>
    </Link>
  )
}
